import { PatientBanner as NovaPatientBanner, PatientBannerProps as NovaPatientBannerProps } from '@fme-nova/components'
import React from 'react'

import { createComponentWrapperWithRef } from '../../theme'

export const PatientBanner = createComponentWrapperWithRef<NovaPatientBannerProps>(
  {
    mui: React.Fragment,
    nova: NovaPatientBanner,
  },
  'PatientBanner',
)
